{
  "version": 1,
  "asset_id": "2ea4d4e3-bf2d-4b49-b77a-6beaa80d2d59",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/2ea4d4e3-bf2d-4b49-b77a-6beaa80d2d59/dilated-pouch-contrast-980.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/2ea4d4e3-bf2d-4b49-b77a-6beaa80d2d59/dilated-pouch-contrast-980.jpg",
  "original_filename": "dilated-pouch-contrast-980.jpg",
  "size": 89795,
  "content_type": "image/jpeg",
  "created_at": "2026-09-20T23:09:09Z"
}
